import { EventPage } from "../GA";
import _ from "lodash";

export const QLD_SITE = "https://www.qld.gov.au";

export const INFINITE_NUMBER = Math.pow(2, 31) - 1;
export const SEPARATOR = "###";
export const SEARCH_PAGE_QUERY_PARAM_SPLITTER = "!!";
export const QUERY_URL_AND = "&";
export const TEAL = "#277e8b";
export const CHARCOAL = "#333";
export const LIGHT_GREY = "#EEEEEE";
export const LIGHT_GREY_2 = "#ababae";
export const LIGHT_GREY_3 = "#fafafa";

export const ZERO_OPACITY = "rgba(255, 255, 255, 0)";

export const EMPTY_OBJECT = {};
export const EMPTY_ARRAY = [];

export const SITE_TITLE = "Queensland’s Urban Water Explorer";

export const ROUTE = {
    // FAQ: "/faq",
    FAQ: "/urban-water-sector",
    ABOUT: "/about",
    HOME: "/",
    // SEARCH_PAGE: "/search",
    SEARCH_PAGE: "/explore-providers",
    PROVIDER_INFO: "/provider",
    PROVIDER_SELECT_TO_COMPARE: "/select",
    PROVIDER_COMPARE: "/compare"
};

export const ROUTE_TITLE_PREFIX = {
    ABOUT: `About this explorer`,
    FAQ: `Queensland's Urban Water Sector`,
    HOME: `Home`,
    SEARCH_PAGE: `Explore providers`,
    PROVIDER_INFO: `Provider info`,
    PROVIDER_SELECT_TO_COMPARE: `Provider select for comparison`,
    PROVIDER_COMPARE: `Provider comparison`
};

export const ROUTE_GA_EVENT_PAGE: Record<string, EventPage> = {
    ABOUT: "about",
    FAQ: `faq`,
    HOME: `home`,
    SEARCH_PAGE: `exploreProviders`,
    PROVIDER_INFO: `providerInfo`,
    PROVIDER_SELECT_TO_COMPARE: `providerComparison`,
    PROVIDER_COMPARE: `providerSelectToCompare`
};

export const ROUTE_TITLE = {
    ABOUT: `${ROUTE_TITLE_PREFIX.ABOUT} | ${SITE_TITLE}`,
    FAQ: `${ROUTE_TITLE_PREFIX.FAQ} | ${SITE_TITLE}`,
    HOME: `${ROUTE_TITLE_PREFIX.HOME} | ${SITE_TITLE}`,
    SEARCH_PAGE: `${ROUTE_TITLE_PREFIX.SEARCH_PAGE} | ${SITE_TITLE}`,
    PROVIDER_INFO: `${ROUTE_TITLE_PREFIX.PROVIDER_INFO} | ${SITE_TITLE}`,
    PROVIDER_SELECT_TO_COMPARE: `${ROUTE_TITLE_PREFIX.PROVIDER_SELECT_TO_COMPARE} | ${SITE_TITLE}`,
    PROVIDER_COMPARE: `${ROUTE_TITLE_PREFIX.PROVIDER_COMPARE} | ${SITE_TITLE}`
};

export const DEFAULT_FLY_TO = [137.994599989, -29.177874667, 153.552171248, -9.14249600899996];
export const MAP_MIN_ZOOM = 4;
export const MAP_MAX_ZOOM = 12;
export const MAP_CENTER = [145.107421875, -22.63429269379352];
export const DEFAULT_MAX_BOUNDS = [
    138.0322265625, -29.11377539511439,

    154.70947265625, -8.602747284770006
    // -9.535748998133615
];

// 154.16015625, -11.350796722383672];
// [123.57421875, -35.06597313798418, 164.443359375, -4.390228926463384];
export const PROVIDER_FIELDS = _.join(
    [
        "its_tid",
        "pure_strings_region",
        "pure_strings_type",
        "pure_strings_admin_id",
        "pure_strings_kapi_name",
        "pure_strings_sname",
        "pure_strings_stax_name",
        "pure_strings_connection_size_ct",
        "pure_strings_residential_tariff_struct",
        "fts_connection_size",
        "fts_sewerage_connection_size",
        "fts_population",
        "fts_area",
        "fts_dam_capacity",
        "fts_dam_num",
        "fts_employee_num",
        "bs_include_imported_water",
        "tm_X3b_en_description"
    ],
    ","
);

export const PROVIDER_SHAPE_FIELDS = _.join(
    ["its_tid", "pure_strings_admin_id", "geojsons_geometry", "geojsons_scheme_geometry"],
    ","
);
export const tracker = {
    providerPageNavHistoryIndex: undefined
};

const NA = "Not applicable";
const MD = "Missing data";
const NR = "Not relevant";
const RD = "Data removed";

export const VALUE_STATUS_NAMING: Record<"MD" | "NR" | "NA" | "RD", string> = {
    MD: MD,
    NR: NR,
    NA: NA,
    RD: RD
};

export const isValueExceptionMessage = (value: string) => {
    const exceptionMessageToOne = _.values(VALUE_STATUS_NAMING).reduce((prev, curr) => {
        prev[curr?.toString()?.toLowerCase()] = 1;
        return prev;
    }, {});

    return exceptionMessageToOne[value?.toLowerCase()?.toString()] === 1;
};

export const PROVIDER_CONNECTION_TYPE = {
    bulk: "bulk"
};

export const WATER_SUPPLY_LENGTH_OF_MAINS = "water-supply-general-capacity-length-of-mains";
export const BILLING_ANNUAL_RESIDENTIAL_BILL = "billing-typical-annual-residential-bill";
export const BILLING_ANNUAL_BILLING_BASED_ON_200KL = "billing-annual-billing-based-on-200kl-per-annum";
export const SEWERAGE_SERVICES = "sewerage-services";
export const PROVIDER_TITLE_CLASS = "provider-title";
export const CONFIDENCE_KEYWORD_IN_SUPPLY_DEMAND_KPI_TITLE = "confidence";
export const WATER_SUPPLY_LENGTH_OF_MAINS_KPI_CODE = "QG 1.1";
export const SEWERAGE_LENGTH_OF_MAINS_KPI_CODE = "QG 1.2";
export const WATER_SUPPLY_WATER_TREATMENT_COUNT = "QG 1.4a";
export const WATER_SUPPLY_DEMAND_MONTHS_OF_AVAILABLE_SUPPLY = "QG 2.12";
export const SEWERAGE_WATER_TREATMENT_COUNT = "QG 1.3";
export const RESIDENTIAL_CONNECTION_PROPERTIES_COUNT_KPI_CODE = "QG 1.13";
export const NONRESIDENTIAL_CONNECTION_PROPERTIES_COUNT_KPI_CODE = "QG 1.14";
export const RESIDENTIAL_POTABLE_WATER_SUPPLY_KPI_CODE = "QG 1.17a";
export const NONRESIDENTIAL_POTABLE_WATER_SUPPLY_KPI_CODE = "QG 1.18a";
export const WATER_SUPPLY_OPERATING_COST_KPI_CODE = "CPI - QG 3.11a";
export const SEWERAGE_OPERATING_COST_KPI_CODE = "CPI - QG 3.12a";
export const WATER_SUPPLY_CAPEX_KPI_CODE = "CPI - QG 3.1";
export const SEWERAGE_CAPEX_KPI_CODE = "CPI - QG 3.2";
export const WATER_SUPPLY_OTHER_COST_KPI_CODE = "CPI - QG 3.21";
export const SEWERAGE_OTHER_COST_KPI_CODE = "CPI - QG 3.22";
export const TYPICAL_ANNUAL_RESIDENT_BILL_KPI_CODE = "CPI - QG 4.4";
export const BILLING_ANNUAL_BILLING_BASED_ON_200KL_KPI_CODE = "CPI - QG 4.3";
export const WATER_SERVICE_PROVIDER = "WSP";

export const WATER_SECURITY_SUPPLY_DEMAND_MONTHS_OF_AVAILABLE_SUPPLY_VALUE_TO_LABEL = {
    1: "0-3 months of avaliable supply",
    2: "4-6 months of avaliable supply",
    3: "7-12 months of avaliable supply",
    4: "13-18 months of avaliable supply",
    5: "19-59 months of avaliable supply",
    6: "60 months or greater of avaliable supply"
};
export const QUEENSLAND_BULK_SUPPLIER = "QBWSA";
export const OPENDATA_DATA_DOWNLOAD_LINK =
    "https://www.data.qld.gov.au/dataset/water-and-sewerage-service-provider-qld-key-performance-indicator-data/resource/7ea7771a-5713-4630-9c4d-3cbbd4034b4c";
